import { FetchResult } from '@apollo/client';

export default class UnauthorizedError extends Error {
  constructor(public readonly originalResult: FetchResult) {
    super();
  }
}
